import { css } from '@styled-system/css';
import { stack } from '@styled-system/patterns';
import { token } from '@styled-system/tokens';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PuffLoader } from 'react-spinners';

export const AnalysisMenuLoadingState: FC = () => {
  const { t } = useTranslation();
  const containerStyles = stack({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    h: '12rem',
    gap: '1rem',
  });

  const textStyles = css({
    fontSize: '2xs',
    fontWeight: 500,
    color: 'font.lowkey', // #4f5055
    textAlign: 'center',
  });

  const colorResolved = token.var('colors.accent.primary');

  return (
    <div className={containerStyles}>
      <PuffLoader color={colorResolved} size={40} speedMultiplier={0.8} />
      <div className={textStyles}>{t('analysisMenu.loading')}</div>
    </div>
  );
};
